import { render, staticRenderFns } from "./qunfaDetail.vue?vue&type=template&id=a8bb3560&scoped=true&"
import script from "./qunfaDetail.vue?vue&type=script&lang=js&"
export * from "./qunfaDetail.vue?vue&type=script&lang=js&"
import style0 from "./qunfaDetail.vue?vue&type=style&index=0&id=a8bb3560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8bb3560",
  null
  
)

export default component.exports